import { useNavigate } from 'react-router-dom'

/**
 * Page header with title, back button, and optional action buttons.
 * Theme-aware navigation header (light/dark).
 */
export default function PageHeader({ title, showBack = false, backTo, actions }) {
  const navigate = useNavigate()

  function handleBack() {
    if (backTo) {
      navigate(backTo)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="bg-white dark:bg-dial-surface border-b border-gray-200 dark:border-dial-border px-4 py-3 flex items-center justify-between safe-area-inset-top sticky top-0 z-10">
      <div className="flex items-center min-w-0 flex-1">
        {showBack && (
          <button
            onClick={handleBack}
            className="p-2 -ml-2 text-primary-600 dark:text-lume-teal hover:text-primary-700 dark:hover:text-lume-green transition-colors flex-shrink-0"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <h1 className={`font-semibold text-gray-900 dark:text-indices-bright text-lg truncate font-display ${showBack ? 'ml-1' : ''}`}>
          {title}
        </h1>
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-shrink-0 ml-2">
          {actions}
        </div>
      )}
    </div>
  )
}
